module.exports = __webpack_public_path__ + "static/img/05-gsjj.610b5a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/05-gsjj.jpg
// module id = JeKQ
// module chunks = 1